<div class="container" [ngClass]="selected ? 'selected' : ''" role="tab" [attr.aria-selected]="selected"
	[attr.tabindex]="tabIndexValue !== null ? tabIndexValue : (selected ? 0 : -1)" (click)="onClick()"
	(keydown.enter)="onClick()" (keydown.space)="onSpaceKey($event)">
	{{ label }}
</div>